import path from "./path.js";
import math from "core/math";
/**
 * Draw multiple lines.
 * @public
 * @method drawJoinedLines
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context - Target context
 * @param {HTMLElement} element - The DOM Element to draw on
 * @param {Object[]} lines - `[{ start: {x, y}, end: { x, y }]` An array of `start`, `end` pairs.
 *     Each point is `{ x, y }` in either pixel or canvas coordinates.
 * @param {Object} options - See {@link path}
 * @param {String} [coordSystem='pixel']
 * @returns {undefined}
 */
export default function(
  context,
  element,
  lines,
  options,
  coordSystem = "pixel"
) {
  path(context, options, context => {
    lines.forEach(line => {
      let start = line.start;
      let end = line.end;

      if (coordSystem === "pixel") {
        start = math.coordinate.pixelToCanvas(element, start);
        end = math.coordinate.pixelToCanvas(element, end);
      }

      context.moveTo(start.x, start.y);
      context.lineTo(end.x, end.y);
    });
  });
}
